import Axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'produk',
    state: {
        produk: [],
        rndproduk: []
    },
    getters: {
        getAllProduk: state => {
            return state.produk
        },
        getAllProdukRND: state => {
            return state.rndproduk
        },
    },
    mutations: {
        SET_PRODUK: (state, payload) => {
            state.produk = payload
        },
        SET_PRODUKRND: (state, payload) => {
            state.rndproduk = payload
        },
    },
    actions: {
        async FETCH_PRODUK(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "sales_notification/product",
                params: {
                    tlc: store.rootState.user.auth.username
                },
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('SET_PRODUK', response.data.list_product)
            })
                .catch(err => {
                    return err
                });
        },
        async FETCH_PRODUKRND(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "rnd_notification/product",
                params: {
                    tlc: store.rootState.user.auth.username
                },
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('SET_PRODUKRND', response.data.list_product)
            })
                .catch(err => {
                    return err
                });
        },
    }
}